import {
  SET_TURNOS_RECEPCIONADOS,
  SET_TURNOS_RECEPCIONADOS_ALL,
} from "../ActionTypes";
import turnosSeleccionadosInitialState from "../initialState/turnosSeleccionadosInitialState";

const turnosRecepcionados = (state, { payload, type }) => {
  switch (type) {
    case SET_TURNOS_RECEPCIONADOS:
      return {
        ...state,
        turnosRecepcionados: {
          ...state.turnosRecepcionados,
          loading: false,
          error: false,
          data: [...state.turnosRecepcionados.data, payload],
        },
      };
    case SET_TURNOS_RECEPCIONADOS_ALL:
      return {
        ...state,
        turnosRecepcionados: {
          ...state.turnosRecepcionados,
          loading: false,
          error: false,
          data: payload,
        },
      };

    default:
      return turnosSeleccionadosInitialState;
  }
};

export default turnosRecepcionados;
